<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Auto-Schedule Workflows'"
      
      [customBack]="backPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      @if (hasSyncPending) {
        <tidy-alert>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/yellow-pending.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Sync Pending'" />
          </tidy-row>
          <tidy-text
            [body]="'TIDY is syncing the integration you added. Please check back soon.'" />
        </tidy-alert>
      }
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'TIDY can automatically book a job for your pros when a reservation is synced.'" /><span>&nbsp;</span>
          <tidy-text
            [actionBody]="'Learn More'"
            (action)="learnMoreAutomaticBooking()"
            class="link" />
        </tidy-row>
        <tidy-alert>
          <form [formGroup]="form" novalidate action="#">
            <tidy-row class="field-top-padding" style="padding-bottom:0px">
              <tidy-input
                #searchInput
                [icon]="'assets/svg/search.svg'"
                [noBorder]="true"
                type="search"
                formControlName="search"
                [label]="'Search'"
                [form]="form" />
            </tidy-row>
          </form>
        </tidy-alert>
        @if (addresses?.length == 0) {
          <tidy-alert>
            <tidy-text
              [body]="'No results'" />
          </tidy-alert>
        }
        @for (address of addresses; track address) {
          <tidy-card>
            <tidy-card-button (action)="goToAutomaticBookingAddress(address)" class="arrow-to-top">
              <tidy-row class="vertical-align-center">
                @if (address?.address_automatic_booking_setting?.automatic_booking_enabled) {
                  <tidy-image
                    [src]="'assets/img/checkmark.svg'"
                    class="body-size" />
                }
                @if (!address?.address_automatic_booking_setting?.automatic_booking_enabled) {
                  <tidy-image
                    [src]="'assets/img/block.svg'"
                    class="body-size" />
                }
                @if (!address?.address_name) {
                  <tidy-text
                    [body]="address?.address1"
                    [translate]="false" />
                }
                @if (address?.address_name) {
                  <tidy-text
                    [body]="address?.address_name"
                    [translate]="false" />
                }
              </tidy-row>
              @if (address?.address2 && !address?.address_name) {
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/home.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="address?.address2"
                    [translate]="false" />
                </tidy-row>
              }
              @if (address?.address_automatic_booking_setting?.automatic_booking_enabled) {
                <tidy-row class="extra-top-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/suitcase.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="address?.address_automatic_booking_setting?.required_team_service?.name" />
                </tidy-row>
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/clock.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="(address?.address_automatic_booking_setting?.booking_start_time_no_earlier_than | parseDateTime:'h:mma') + ' - ' + (address?.address_automatic_booking_setting?.booking_end_time_no_later_than | parseDateTime:'h:mma')" />
                </tidy-row>
              }
              @if (!address?.address_automatic_booking_setting) {
                <tidy-row>
                  <tidy-text
                    [helper]="'No Integration Synced'" />
                </tidy-row>
              }
            </tidy-card-button>
          </tidy-card>
        }
      }

      @if (!loaded) {
        <tidy-row>
          <ion-skeleton-text animated="true" style="width: 100%; height:14px" />
          <ion-skeleton-text animated="true" style="width: 230px; margin: auto; height:14px" />
        </tidy-row>
        <tidy-alert style="width: 100%; height:70px" />
        @for (card of [1,2,3,4,5,6,7]; track card) {
          <tidy-card>
            <tidy-card-button [hideArrow]="true">
              <tidy-row class="extra-bottom-padding">
                <ion-skeleton-text animated="true" style="width: 130px; height: 14px" />
              </tidy-row>
              <tidy-row>
                <ion-skeleton-text animated="true" style="width: 120px; height: 14px" />
              </tidy-row>
              <tidy-row>
                <ion-skeleton-text animated="true" style="width: 140px; height: 14px" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
      }

    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
